import { useEffect, useState } from "react";

/**
 * Subscribe to a CSS media query and return whether it currently matches.
 *
 * SPA-only: this app has no SSR, so reading `window.matchMedia` during the
 * initial render is safe and avoids a hydration flash.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** True at Tailwind's `lg` breakpoint (>=1024px) and up. */
export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 1024px)");
}
